import { useField } from 'formik';
import { MentionFromCustomField } from './MentionFromCustomField';
import { MentionFromSchedulesField } from './MentionFromSchedulesField';
import { Station } from '@app/core/types/stations';

interface Props {
  station: Station;
}

export function MentionNameFields({ station }: Props) {
  const [{ value }] = useField('source');

  return (
    <div>
      {value === 'custom' && <MentionFromCustomField />}
      {value === 'schedules' && <MentionFromSchedulesField stationId={station.id} />}
    </div>
  );
}
